import { Fragment } from 'react';
import Breadcrumbs from 'shell/components/shared/breadcrumb';
import { CommonMinisterReligionCrumbs } from 'civil-status/constants/place';
import { useParams } from 'react-router-dom';
import { useHttpFetch } from 'shell/hooks/use-http-fetch';
import { HttpResponse } from 'shell/models/http-response';
import { PlaceForm } from 'civil-status/view-models/place';
import { transformResponse } from 'civil-status/utils/place';
import { __ACT_API_URL__ } from 'shell/constants/environment';
import { MunicipalityValueDomainType } from 'shell/models/value-domain-type';
import { DomainType } from 'civil-status/constants/domain';
import FormPlace from 'civil-status/components/place/form';

const MinisterReligionDetailPage = (): React.ReactElement => {
  const params = useParams();

  const [ministerReligionData] = useHttpFetch<HttpResponse<MunicipalityValueDomainType>, PlaceForm>(
    `${__ACT_API_URL__}/valori-dominio-atti/${DomainType.MinisterReligion}/${params.id}`,
    {
      onBootstrap: true,
      options: {
        method: 'GET',
        loading: true,
        errorCatching: true,
      },
      transformer: transformResponse,
    }
  );

  const values = ministerReligionData.data as PlaceForm;

  return (
    <Fragment>
      <Breadcrumbs
        items={[...CommonMinisterReligionCrumbs, { name: 'Visualizza ministro di culto' }]}
      />
      {ministerReligionData.isLoading ||
      ministerReligionData.pristine ||
      ministerReligionData.error ? undefined : (
        <FormPlace
          title="Visualizza ministro di culto"
          disabled
          initialValues={values}
          isMinisterReligion
        />
      )}
    </Fragment>
  );
};

MinisterReligionDetailPage.displayName = 'Minister Religion detail page component';

export default MinisterReligionDetailPage;
